/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';

export const fetchArenas = createRoutine('FETCH_ARENAS');
